import { IContainer, injectContainer } from "./container";


export interface IConfigAPI {
    url: string,
    auth: {
        clientId: string,
        clientSecret: string,
        grantType: string,
        username: string,
        password: string,
    },
    extension: {
        auth: string,
        siteData: string,
        mediaDiff: string,
        media: string,
    }
}

export interface IConfigAssets {
    flags: Record<string,string>
}

export enum IConfigCacheName {
    Undef = 0,
    BuildAssets = 1,
    PublicAssets = 2,
    WorkspaceMedia = 3,
    AppToken = 4,
    LastValue = 5,
}

export interface IConfigCacheAssets {
    cacheName: string;
    expiration: number;
    maxEntries: number;
    matcher: RegExp;
}

export type IConfigCache = Record<IConfigCacheName,IConfigCacheAssets>;

export enum IConfigRoutePath {
    Undef = 0,
    Launch = 1,
    LanguageSelect = 2,
    TourSelect = 3,
    Tour = 4,
    SiteObject = 5,
    FloorPlan = 6,
    LastValue = 7,
}

export interface IRouteConfigSettings {
    pathPrefix: string;
    pathMatch: Array<string>;
}

export type IConfigRoute = Record<IConfigRoutePath,IRouteConfigSettings>;

const TYPES = {
    IConfigAPI: Symbol.for("IConfigAPI"),
    IConfigAssets: Symbol.for("IConfigAssets"),
    IConfigCache: Symbol.for("IConfigCache"),
    IConfigRoute: Symbol.for("IConfigRoute"),
}

export function injectConfigAPI(container: IContainer = injectContainer()): IConfigAPI {
    return container.get<IConfigAPI>(TYPES.IConfigAPI);
}

export function bindConfigAPI(val:IConfigAPI, container: IContainer = injectContainer()) {
    return container.bind<IConfigAPI>(TYPES.IConfigAPI, val);
}


export function injectConfigAssets(container: IContainer = injectContainer()): IConfigAssets {
    return container.get<IConfigAssets>(TYPES.IConfigAssets);
}

export function bindConfigAssets(val:IConfigAssets, container: IContainer = injectContainer()) {
    return container.bind<IConfigAssets>(TYPES.IConfigAssets, val);
}


export function injectConfigCache(container: IContainer = injectContainer()): IConfigCache {
    return container.get<IConfigCache>(TYPES.IConfigCache);
}

export function bindConfigCache(val:IConfigCache, container: IContainer = injectContainer()) {
    return container.bind<IConfigCache>(TYPES.IConfigCache, val);
}


export function injectConfigRoute(container: IContainer = injectContainer()): IConfigRoute {
    return container.get<IConfigRoute>(TYPES.IConfigRoute);
}

export function bindConfigRoute(val:IConfigRoute, container: IContainer = injectContainer()) {
    return container.bind<IConfigRoute>(TYPES.IConfigRoute, val);
}
